import React, { ErrorInfo } from 'react'

import { isEmpty } from 'lodash'
import { connect } from 'react-redux'

import Error from '../../pages/Error/Error'
import { APP_PATHS } from '../../routes/paths'
import { RootState } from '../../store'

import { ErrorBoundaryState, ErrorBoundaryProps, IGlobalErrorData } from './types'

const initialState: ErrorBoundaryState = {
  hasError: false,
  error: undefined,
  errorInfo: undefined,
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = initialState
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState((state) => ({ ...state, error, errorInfo }))
  }

  componentDidUpdate(
    prevProps: Readonly<ErrorBoundaryProps>,
    prevState: Readonly<ErrorBoundaryState>,
  ) {
    if (prevState.hasError !== this.state.hasError) {
      this.props.navigate(APP_PATHS.error)
    }
  }

  render() {
    if (this.state.hasError || !isEmpty(this.props.axiosErrorData)) {
      let errorProps = {
        frontendError: undefined,
        backendError: undefined,
      } as IGlobalErrorData

      if (this.state.hasError) {
        errorProps = {
          ...errorProps,
          frontendError: {
            code: 'REACT_APP_CRASH_REPORT',
            time: new Date().toISOString(),
            stack: `
              ${this.state.error?.toString()}
              ${this.state.errorInfo?.componentStack}
            `,
            message: 'React app render error',
          },
        }
      }

      if (!isEmpty(this.props.axiosErrorData)) {
        errorProps = {
          ...errorProps,
          backendError: this.props.axiosErrorData,
        }
      }

      return <Error data={errorProps} />
    }

    return this.props.children
  }
}

export default connect((state: RootState) => ({ axiosErrorData: state.error.errorData }))(
  ErrorBoundary,
)
